import React, { useState, useEffect } from 'react';
import { FiAlertTriangle } from 'react-icons/fi';
import { useUser, useOrganization } from '@clerk/clerk-react';

const AlwaysVisibleFloatingButton = () => {
  const { user } = useUser();
  const { organization } = useOrganization();
  const [hasOrganizations, setHasOrganizations] = useState(false);
  const [isChecking, setIsChecking] = useState(true);

  useEffect(() => {
    const checkUserOrganizations = async () => {
      if (!user) {
        setHasOrganizations(false);
        setIsChecking(false);
        return;
      }

      try {
        const memberships = await user.getOrganizationMemberships();
        const hasOrgs = memberships.data && memberships.data.length > 0;
        setHasOrganizations(hasOrgs);
      } catch (error) {
        console.error('Error checking user organizations:', error);
        setHasOrganizations(false);
      } finally {
        setIsChecking(false);
      }
    };

    checkUserOrganizations();
  }, [user, organization]);

  // Don't show if user has organizations or if we're still checking
  if (isChecking || hasOrganizations || organization) {
    return null;
  }

  // Only show the floating button if user truly has no organizations
  return (
    <div className="fixed bottom-6 right-6 z-40">
      <button
        onClick={() => window.location.href = '/organization'}
        className="bg-blue-600 hover:bg-blue-700 text-white p-4 rounded-full shadow-lg hover:shadow-xl transition-all duration-200 transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-offset-2"
        title="Organization Required - Click to create or join an organization"
      >
        <FiAlertTriangle size={24} />
      </button>
      
      {/* Tooltip */}
      <div className="absolute bottom-full right-0 mb-2 px-3 py-2 bg-gray-900 text-white text-sm rounded-lg shadow-lg whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none">
        Organization Required
        <div className="absolute top-full right-4 w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent border-t-gray-900"></div>
      </div>
    </div>
  );
};

export default AlwaysVisibleFloatingButton; 